import React from 'react';
import UserForm from '../UserForm';

interface ResponsibleFormProps {
  defaultValues?: any;
}

const RESPONSIBLE_GROUP = {
  id: 5,
  name: 'Responsável',
};

export default function ResponsibleForm({ defaultValues = {} }: ResponsibleFormProps) {
  return (
    <UserForm
      defaultValues={defaultValues}
      fixedGroup={RESPONSIBLE_GROUP}
      returnPage="responsible"
      entityLabel="Responsável"
      backLabel="Responsáveis"
      requireCellPhone
    />
  );
}
